import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Screen } from '@/components/layout/Screen';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  KnowledgeBase,
  PeerInsights,
  KnowledgeSearch,
} from '@/features/agriagent/knowledge';
import { 
  BookOpen, 
  Users,
  Search
} from 'lucide-react';

export const KnowledgeScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'browse');

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearchParams({ tab: value });
  };

  const handleAskAgent = (question: string) => {
    navigate(`/agent?q=${encodeURIComponent(question)}`);
  };

  const tabs = [
    { id: 'browse', labelKey: 'knowledge.tabs.browse', icon: BookOpen },
    { id: 'search', labelKey: 'knowledge.tabs.search', icon: Search },
    { id: 'peers', labelKey: 'knowledge.tabs.peers', icon: Users },
  ];

  return (
    <Screen
      showTopBar={true}
      showBottomNav={true}
      topBarProps={{
        title: t('knowledge.title'),
        showBack: true,
        onBack: () => navigate(-1),
      }}
      className="flex flex-col"
    >
      <Tabs value={activeTab} onValueChange={handleTabChange} className="flex-1 flex flex-col">
        <TabsList className="w-full justify-start overflow-x-auto flex-shrink-0 rounded-none border-b">
          {tabs.map(tab => (
            <TabsTrigger key={tab.id} value={tab.id} className="gap-2">
              <tab.icon className="h-4 w-4" />
              <span className="hidden sm:inline">{t(tab.labelKey)}</span>
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="browse" className="flex-1 mt-0">
          <KnowledgeBase onAskAgent={handleAskAgent} />
        </TabsContent>

        <TabsContent value="search" className="flex-1 mt-0">
          <KnowledgeSearch onAskAgent={handleAskAgent} />
        </TabsContent>

        <TabsContent value="peers" className="flex-1 mt-0">
          <PeerInsights />
        </TabsContent>
      </Tabs>
    </Screen>
  );
};
